import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { config } from 'src/app/config';
import Util from 'src/app/_helpers/util';

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.scss']
})
export class BoardComponent implements OnInit {

  @Input() rfq?: any;
  @Input() rfqType?: string='vendor'; //procurement / vendor

  @Input() forceMobile?: boolean=false; // homepage
  config:any
  constructor() { }

  ngOnInit(): void {
    this.config = config
    console.log('rfq board masuk :: ',this.rfq)
    this.rfq.node = this.rfq

    // city
    // country
    // submitQuotationLastDate
    // totalVendorParticipation
    // procurementName
    // rfqState
    // isAlreadyParticipating
    // rfqVendorCategory
    // rfqDisplayId
    // description
    // rfqItem
    // haveMoreRfqItem
    
  }

  divDetailspec(val:any){
    var divdet = Util.formatShortDesc(val)
    if(divdet.length>50){
      divdet = divdet.substring(0, 50) + ' ...'
    }
    return divdet
  }
  divDetailspecMobile(val:any){
    var divdet = Util.formatShortDesc(val)
    if(divdet.length>30){
      divdet = divdet.substring(0, 30) + ' ...'
    }
    return divdet
  }

  formatDisplayId(displayId: any) {
    if(displayId){
      var re = new RegExp('.{1,4}', 'g');
      return displayId.match(re).join("-");
    } else{
      return ""
    }

  }
  
}
